import img from "./images/me.jpg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ArrowDown, Download } from "lucide-react";
import SocialDock from "./SocialDock";

const stats = [
  { value: "3", label: "Published papers" },
  { value: "2", label: "Engineering degrees" },
  { value: "1", label: "Automotive R&D role" },
  { value: "7", label: "Featured projects" },
];

export default function Hero() {
  return (
    <section id="hero" className="d-flex flex-column justify-content-center">
      <Container className="hero-container">
        <Row className="align-items-center hero-row">
          <Col lg={7} className="hero-copy">
            <span className="eyebrow">Robotics software · Automotive R&amp;D</span>
            <h1>Barham Farraj</h1>
            <h2>Robotics Software Engineer</h2>
            <p className="hero-stack">ROS 2 <span>•</span> Embedded Linux <span>•</span> Autonomous Systems <span>•</span> LiDAR <span>•</span> C++</p>
            <p className="hero-intro">Building autonomous robots and industrial embedded systems from research to production.</p>
            <div className="hero-actions">
              <a className="primary-cta" href="#projects">Explore my work <ArrowDown size={18} /></a>
              <a className="secondary-cta" target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1ANIvJJKhsT-hOi4thgFDe0-Gjq2vFGfLRCgpOqYGRlE/edit?usp=sharing">
                <Download size={18} /> Download CV
              </a>
            </div>
            <SocialDock />
          </Col>
          <Col lg={5} className="hero-visual">
            <div className="portrait-frame">
              <img src={img} alt="Barham Farraj, robotics software engineer" />
              <span className="availability-dot" aria-hidden="true" />
              <p>Based in Slovakia · Working across robotics and automotive systems</p>
            </div>
          </Col>
        </Row>
        <div className="hero-stats" aria-label="Career highlights">
          {stats.map((stat) => (
            <div className="hero-stat" key={stat.label}>
              <strong>{stat.value}</strong><span>{stat.label}</span>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
